module.exports = "<div class=\"container\">\n  <h1>{{ title }}</h1>\n  <p>{{ description }}</p>\n</div>\n"